import { render, staticRenderFns } from "./EnvironmentInfo.vue?vue&type=template&id=1ca01bd0&scoped=true"
import script from "./EnvironmentInfo.vue?vue&type=script&lang=js"
export * from "./EnvironmentInfo.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentInfo.vue?vue&type=style&index=0&id=1ca01bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca01bd0",
  null
  
)

export default component.exports